var slideDown = {
	open: function( $item ) {
		var $content = $item.find( '.sd-content' ),
			h = $content.children( '.inner' ).outerHeight( true );

		$content.css( { 'max-height': h } );
		$( 'body' ).icons.init( '.svg-icon' );
	},
	close: function( $item ) {
		var $content = $item.find( '.sd-content' );
		$content.css( { 'maxheight': '0' } );
		setTimeout( function() {
				$item.removeClass( 'open' ).find( '.sd-content' ).removeAttr( 'style' );
		}, 300 );
	},
	openCloseContent: function() {
		if ( $( '.js-slidedown' ).length > 0 ) {
			$( '.sd-item > h5' ).on( 'click', function( e ) {
				e.preventDefault();
				var $item = $( this ).closest( '.sd-item' );
				if ( $item.hasClass( 'open' ) ) {
					slideDown.close( $item );
				} else {
					$item.siblings( 'li' ).each( function() {
						slideDown.close( $(this) );
					} );
					setTimeout( function() {
						slideDown.open( $item );
						$item.addClass( 'open' );
					}, 300 );
					// setTimeout( function() {
					// 	//if ( Modernizr.mq( '(max-width: 1023px)' ) ) {
					// 		$( 'html, body' ).animate( { scrollTop: $item.find('h5').offset().top - 80 }, 500 );
					// 	//}
					// }, 600 );
				}
			});
		}
	},
	init: function() {
		slideDown.openCloseContent();

		// If alreay open:
		$( '.sd-item' ).each( function() {
			var $item = $( this );
			if ( $item.hasClass( 'open' ) ) {
				slideDown.open( $item );
				// Fix:
				if ( $item.is( ':not(.open)' ) ) {
					$( '.sd-item.open' ).removeClass( 'open' ).find( '.sd-content' ).removeAttr( 'style' );
				}

			}

		} );
	},
};
 export { slideDown };
